
import {Container} from 'react-bootstrap';

const AdminPage = () => {

    return (
        <Container fluid className='admin-decorator'>
            <div className='admin-decorator__title'>
                Главная страница
            </div>
            <div className='admin__mainpage'>
                <div className='admin__mainpage__title'>
                    Административный раздел сайта: Имя сайта
                </div>
                <div className='admin__mainpage__text'>
                    На главной странице CMS будет размещена справочная информация для контент-менеджеров и администраторов сайта.
                </div>
            </div>
        </Container>
    )
}

export default AdminPage;